<template>
  <div class="help-center" v-if="!zlj">
    <user-section></user-section>
    <!-- 自助服务 -->
    <self-service zz-sectionid="1"></self-service>
    <!-- 服务进度 -->
    <order-service-section zz-sectionid="2"></order-service-section>
    <!-- 推荐阅读 -->
    <common-question zz-sectionid="3"></common-question>
    <!-- 咨询分类 -->
    <question-category zz-sectionid="4"></question-category>
    <div class="help-center-holder"></div>
  </div>
  <div v-else>
    <zlj-help-center />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import QuestionCategory from './QuestionCategory/QuestionCategory'
import CommonQuestion from './CommonQuestion/CommonQuestion'
import SelfService from './SelfService/SelfService'
import UserSection from './UserSection/UserSection'
import OrderServiceSection from './OrderServiceSection'

export default {
  name: 'HelpCenter',
  components: {
    SelfService,
    CommonQuestion,
    QuestionCategory,
    UserSection,
    OrderServiceSection,
    ZljHelpCenter: () => import('./HelpCenterZlj')
  },
  data() {
    return {
      zlj: native.in('zlj') || false
    }
  },
  created() {
    native.setTitle({
      title: '客服中心'
    })
    lego.send({
      pagetype: 'ZZUP_HELPCENTER',
      actiontype: 'PAGE_SHOW'
    })
  }
}
</script>

<style lang="less" scoped>
  @import 'HelpCenter.less';
</style>
